
import { createSlice } from "@reduxjs/toolkit";
import { IFabrixIcons } from "../types";



export interface IconsState {
    icons: IFabrixIcons
}

export const initIconsState: IconsState = {
    icons: {}
}

const IconsSlice = createSlice({
    name: 'icons',
    initialState: initIconsState,
    reducers: {
        setIcons(state, action) {
            let icons = { ...action.payload, ...state.icons}
            state.icons = icons
        }
        
    },
    extraReducers: (builder) => {
    }
});

export const { setIcons } = IconsSlice.actions;
export default IconsSlice.reducer;